<i18n>
{
  "ru":{
    "request_date": "Дата запроса",
    "simplified_payment": "Упрощенный платеж",
    "recurring_payment": "Рекуррентный платеж",
    "recurring_payment_type_1" : "Инициирующий",
    "recurring_payment_type_2": "Повторный",
    "recurring_frequency" :"Периодичность рекуррентов",
    "recurring_expiration" :"Срок подписки на рекурренты",
    "recurring_ref_rrn" :"Инициирующий RRN",
    "recurring_token" :"Токен рекуррентного платежа",
    "misc": "Разное"
  },
  "en":{
    "request_date": "Request date",
    "simplified_payment": "Simplified payment",
    "recurring_payment": "Recurrent payment",
    "recurring_payment_type_1" : "Init",
    "recurring_payment_type_2": "Recurrent",
    "recurring_frequency" :"Recurrent frequency",
    "recurring_expiration" :"Recurrent expiration",
    "recurring_ref_rrn" :"Recurrent RRN reference",
    "recurring_token" :"Recurrent token",
    "misc": "Miscellaneous"
  }
}
</i18n>
<template>
  <el-row class="line-top details" v-loading="loading">
    <el-row :gutter="20" class="ma-2">
      <el-col :span="18" :xs="24">
        <div class="list-item-text">
          {{ $t('request_date') }}:
          <span>{{ paymentLog.request_time }}</span>
        </div>
        <div class="list-item-text">
          {{ $t('po_name') }}:
          <span>{{paymentLog.wsb_order_num }}</span>
        </div>
        <div class="list-item-text" v-if="paymentLog.auth_root">
          {{ $t('billing_name') }}:
          <span>{{ paymentLog.billing_name }}</span>
        </div>
        <div class="list-item-text">
          {{ $t('payment_method') }}:
          <span>{{ paymentLog.payment_method }}</span>
        </div>
        <div class="list-item-text">
          Approval:
          <span>{{ paymentLog.reserv1 ? paymentLog.reserv1 : 'none' }}</span>
        </div>
        <div class="list-item-text" v-if="paymentLog.auth_root">
          ICN:
          <span>{{ paymentLog.reserv2 ? paymentLog.reserv2 : 'none' }}</span>
        </div>
        <div class="list-item-text">
          {{ $t('processing_gateway') }}:
          <span>{{ $t(`processing_gateway_${paymentLog.processing}`) }}</span>
        </div>
        <div class="list-item-text">
          {{ $t('public_offer') }}:
          <span>{{ $t(paymentLog.transaction_log_payment_accept_public_offer === null ? '-' : (parseInt(paymentLog.transaction_log_payment_accept_public_offer) ? 'yes' : 'no')) }}</span>
        </div>
      </el-col>
      <el-col :span="12" :xs="24">
        <div
          class="list-item-text"
          v-if="paymentLog.transaction_log_payment_simplified_payment !== null"
        >
          {{ $t('simplified_payment') }}:
          <span>
            {{
            $t(
            paymentLog.transaction_log_payment_simplified_payment
            ? 'yes'
            : 'no'
            )
            }}
          </span>
        </div>
        <div v-if="paymentLog.transaction_log_payment_recurring_payment > 0">
          <div class="list-item-text">
            {{ $t('recurring_payment') }}:
            <span>
              {{
              $t(
              `recurring_payment_type_${
              paymentLog.transaction_log_payment_recurring_payment
              }`
              )
              }}
            </span>
          </div>

          <div v-if="paymentLog.transaction_log_payment_recurring_frequency">
            <div class="list-item-text">
              {{ $t('recurring_frequency') }}:
              <span>
                {{
                paymentLog.transaction_log_payment_recurring_frequency
                }}
              </span>
            </div>
          </div>
          <div v-if="paymentLog.transaction_log_payment_recurring_expiration">
            <div class="list-item-text">
              {{ $t('recurring_expiration') }}:
              <span>
                {{
                paymentLog.transaction_log_payment_recurring_expiration
                }}
              </span>
            </div>
          </div>
          <div v-if="paymentLog.transaction_log_payment_recurring_ref_rrn">
            <div class="list-item-text">
              {{ $t('recurring_ref_rrn') }}:
              <span>
                {{
                paymentLog.transaction_log_payment_recurring_ref_rrn
                }}
              </span>
            </div>
          </div>
          <div v-if="paymentLog.transaction_log_payment_recurring_token">
            <div class="list-item-text">
              {{ $t('recurring_token') }}:
              <span>
                {{
                paymentLog.transaction_log_payment_recurring_token
                }}
              </span>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row v-if="paymentLog.payment_method === 'cc'" class="ma-3">
      <el-row :gutter="20">
        <el-col :span="6" :xs="24" class="table__log-user-data-title">Agent:</el-col>
        <el-col :span="18" :xs="24" class="table__log-user-data-description">
          {{
          paymentLog.agent
          }}
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6" :xs="24" class="table__log-user-data-title">Agent language:</el-col>
        <el-col :span="18" :xs="24" class="table__log-user-data-description">
          {{
          paymentLog.agent_lang
          }}
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6" :xs="24" class="table__log-user-data-title">System language:</el-col>
        <el-col :span="18" :xs="24" class="table__log-user-data-description">
          {{
          paymentLog.system_lang
          }}
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6" :xs="24" class="table__log-user-data-title">Referer:</el-col>
        <el-col :span="18" :xs="24" class="table__log-user-data-description">
          {{
          paymentLog.referer
          }}
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6" :xs="24" class="table__log-user-data-title">Cookie:</el-col>
        <el-col :span="18" :xs="24" class="table__log-user-data-description">
          {{
          paymentLog.cookie
          }}
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="paymentLog.phone">
        <el-col :span="6" :xs="24" class="table__log-user-data-title">{{ $t('phone') }}:</el-col>
        <el-col :span="18" :xs="24" class="table__log-user-data-description">
          {{
          paymentLog.phone
          }}
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6" :xs="24" class="table__log-user-data-title">Email:</el-col>
        <el-col :span="18" :xs="24" class="table__log-user-data-description">
          {{
          paymentLog.email
          }}
        </el-col>
      </el-row>
    </el-row>
    <el-row v-if="paymentLog.auth_additional_info">
      <h5 class="content-title ma-2">{{ $t('misc') }}:</h5>
      <el-row class="ma-2">
        <pre>{{
          JSON.stringify(
            paymentLog.transaction_payment_method_data
              ? paymentLog.transaction_payment_method_data
              : paymentLog.misc,
            null,
            4
          )
        }}</pre>
      </el-row>
    </el-row>
  </el-row>
</template>

<script>
import apiRes from '../../core/apiRes'

export default {
  name: 'payment-log-details',
  data: () => ({
    loading: true,
    paymentLog: {}
  }),
  props: ['visible', 'url'],
  computed: {
    visibleInner: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('update:visible', false)
        }
      }
    }
  },
  created() {
    this.getPaymentLog()
  },
  methods: {
    getPaymentLog() {
      this.loading = true
      apiRes
        .get(this.url)
        .then(data => {
          this.paymentLog = data.page_vars.tr
          this.paymentLog.request_time = this.paymentLog.request_time
            ? new Date(
              parseInt(this.paymentLog.request_time) * 1000
            ).toLocaleString(this.$locale)
            : '-'
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
